
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.333 5.469C6.973 3.957 9.348 3 12 3s5.027.957 6.667 2.469M7.556 8.185C8.649 7.278 10.232 6.704 12 6.704c1.768 0 3.351.574 4.444 1.481M9.778 11c.547-.454 1.338-.741 2.222-.741.884 0 1.676.287 2.222.741m-9.816 0l-1.353 6.764A2.706 2.706 0 005.707 21h12.587a2.707 2.707 0 001.157-.26 2.707 2.707 0 001.496-2.976L19.594 11","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    